import { Injectable } from "@angular/core";
import { DbCrudHelper } from "@app/shared/services/db-crud-helper";
import { Observable } from "rxjs";
import { ProjectViewColumn } from "../constants/all-view-columns.constants";
import { ProjectListItemData } from "../model/project-list-item";

@Injectable({
    providedIn: "root",
})
export class ProjectListItemDbService {
    constructor(private readonly dbCrudHelper: DbCrudHelper) {}

    public getProjectList(entityId: number, cols: ProjectViewColumn[]): Observable<ProjectListItemData[]> {
        let keys: Array<keyof ProjectListItemData> = [
            // @TODO: Review which of these default keys are actually needed
            "id",
            "currentSubDate",
            "grandfathered",
            "inactive",
            "servicePlanId",
            "userinfo1Id",
            "uuid",
            "featureNestCameras",
            "entityId",
            "lockoutTime",
            ...cols.flatMap(c => c.dbKeys),
        ];
        keys = [...new Set(keys)];

        return this.dbCrudHelper.makeRequest<ProjectListItemData[]>("GetEntityProjects", { id: entityId, keys });
    }
}
